// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"a1a3f863","271":"8561c4c4"}[chunkId] + ".chunk.css";
};